<template>
	<form class="wide" @submit.prevent="submit">
		<div class="sections">
			<section class="section">
				<fieldset>
					<div>
						<div>
							<legend><span>Client Details</span></legend>
						</div>
						<div>
							<div v-if="client.idCheck" class="nothing-to-see-here">
								<p>{{ $present("fullName", client) }} already has an ID check and the status is
									<status-badge :value="client.idCheck.status" group="id-check"/>
								</p>
							</div>
							<template v-else>
								<label><span>Internal Reference Number <span class="optional">— Optional </span></span>
									<div v-if="form.errors.get('client.internal_reference')" class="error-block">
										<p v-html="form.errors.get('client.internal_reference')"></p>
									</div>
									<div>
										<input v-model="form.data.client.internal_reference" type="text">
									</div>
								</label>
								<!--								<label><span>Title <span class="optional">— Optional </span></span>-->
								<!--									<div v-if="form.errors.get('client.title')" class="error-block">-->
								<!--										<p v-html="form.errors.get('client.title')"></p>-->
								<!--									</div>-->
								<!--									<select v-model="form.data.client.title">-->
								<!--										<option disabled selected value="">—</option>-->
								<!--										<option value="Mr">Mr</option>-->
								<!--										<option value="Mrs">Mrs</option>-->
								<!--										<option value="Ms">Ms</option>-->
								<!--										<option value="Miss">Miss</option>-->
								<!--									</select>-->
								<!--								</label>-->
								<label><span>First name </span>
									<div v-if="form.errors.get('client.name_first')" class="error-block">
										<p v-html="form.errors.get('client.name_first')"></p>
									</div>
									<input v-model="form.data.client.name_first" type="text">
								</label>
								<label><span>Last name </span>
									<div v-if="form.errors.get('client.name_last')" class="error-block">
										<p v-html="form.errors.get('client.name_last')"></p>
									</div>
									<input v-model="form.data.client.name_last" type="text">
								</label>
								<label><span>Email </span>
									<div v-if="form.errors.get('client.email')" class="error-block">
										<p v-html="form.errors.get('client.email')"></p>
									</div>
									<input v-model="form.data.client.email" type="text">
								</label>
								<label><span>Date of birth </span>
									<div v-if="form.errors.get('client.dob')" class="error-block">
										<p v-html="form.errors.get('client.dob')"></p>
									</div>
									<v-datepicker v-model="form.data.client.dob"/>
								</label>
								<label><span>Phone </span>
									<div v-if="form.errors.get('client.phone')" class="error-block">
										<p v-html="form.errors.get('client.phone')"></p>
									</div>
									<input v-model="form.data.client.phone" type="text">
								</label>
							</template>
						</div>
					</div>
				</fieldset>
			</section>
			<section v-if="false" class="section">
				<fieldset
					v-for="(relatedClient, relatedClientIndex) in client.relatedClients" :key="relatedClientIndex">
					<!--					<div>-->
					<!--						<div>-->
					<!--							<legend><span>Related Client Details</span></legend>-->
					<!--						</div>-->
					<!--						<div>-->
					<!--							<div v-if="relatedClient.idCheck" class="nothing-to-see-here">-->
					<!--								<p>{{ $present('fullName', relatedClient) }} already has an ID check and the status is <status-badge :value="relatedClient.idCheck.status" group="id-check"/></p>-->
					<!--							</div>-->
					<!--							<template v-else>-->
					<!--								<label><span>Title <span class="optional">— Optional </span></span>-->
					<!--									<div class="error-block" v-if="form.errors.get('related_clients.' + relatedClientIndex + '.title')">-->
					<!--										<p v-html="form.errors.get('related_clients.' + relatedClientIndex + '.title')"></p>-->
					<!--									</div>-->
					<!--									<select v-model="form.data.related_clients[relatedClientIndex].title">-->
					<!--										<option value="" disabled selected>—</option>-->
					<!--										<option value="Mr">Mr</option>-->
					<!--										<option value="Mrs">Mrs</option>-->
					<!--										<option value="Ms">Ms</option>-->
					<!--										<option value="Miss">Miss</option>-->
					<!--									</select>-->
					<!--								</label>-->
					<!--								<label><span>First name </span>-->
					<!--									<div class="error-block" v-if="form.errors.get('related_clients.' + relatedClientIndex + '.name_first')">-->
					<!--										<p v-html="form.errors.get('related_clients.' + relatedClientIndex + '.name_first')"></p>-->
					<!--									</div>-->
					<!--									<input type="text" v-model="form.data.related_clients[relatedClientIndex].name_first">-->
					<!--								</label>-->
					<!--								<label><span>Last name </span>-->
					<!--									<div class="error-block" v-if="form.errors.get('related_clients.' + relatedClientIndex + '.name_last')">-->
					<!--										<p v-html="form.errors.get('related_clients.' + relatedClientIndex + '.name_last')"></p>-->
					<!--									</div>-->
					<!--									<input type="text" v-model="form.data.related_clients[relatedClientIndex].name_last">-->
					<!--								</label>-->
					<!--								<label><span>Email </span>-->
					<!--									<div class="error-block" v-if="form.errors.get('related_clients.' + relatedClientIndex + '.email')">-->
					<!--										<p v-html="form.errors.get('related_clients.' + relatedClientIndex + '.email')"></p>-->
					<!--									</div>-->
					<!--									<input type="text" v-model="form.data.related_clients[relatedClientIndex].email">-->
					<!--								</label>-->
					<!--								<label><span>Phone </span>-->
					<!--									<div class="error-block" v-if="form.errors.get('related_clients.' + relatedClientIndex + '.phone')">-->
					<!--										<p v-html="form.errors.get('related_clients.' + relatedClientIndex + '.phone')"></p>-->
					<!--									</div>-->
					<!--									<input type="text" v-model="form.data.related_clients[relatedClientIndex].phone">-->
					<!--								</label>-->
					<!--							</template>-->
					<!--						</div>-->
					<!--					</div>-->
				</fieldset>
			</section>
			<section class="section">
				<fieldset>
					<div>
						<div>
							<legend><span>Additional ID Checks</span></legend>
						</div>
						<div>
							<label class="checkbox"><span>Do you need any additional ID Checks? </span>
								<input v-model="form.data.additional_id_checks" type="checkbox">
							</label>
							<label
								v-if="form.data.additional_id_checks"><span>How many additional ID Checks do you need? </span>
								<input
									v-model="form.data.number_of_additional_id_checks" type="number"
									@change="setNewClients">
							</label>
						</div>
					</div>
				</fieldset>
			</section>
			<section v-if="form.data.additional_id_checks" class="section">
				<fieldset v-for="(newClient, newClientIndex) in form.data.new_clients" :key="newClientIndex">
					<div>
						<div>
							<legend><span>Additional Client Details</span></legend>
						</div>
						<div>
							<!--							<label><span>Title </span>-->
							<!--								<div-->
							<!--									v-if="form.errors.get('new_clients.' + newClientIndex + '.title')"-->
							<!--									class="error-block">-->
							<!--									<p v-html="form.errors.get('new_clients.' + newClientIndex + '.title')"></p>-->
							<!--								</div>-->
							<!--								<select v-model="form.data.new_clients[newClientIndex].title">-->
							<!--									<option disabled selected value="">—</option>-->
							<!--									<option value="Mr">Mr</option>-->
							<!--									<option value="Mrs">Mrs</option>-->
							<!--									<option value="Ms">Ms</option>-->
							<!--									<option value="Miss">Miss</option>-->
							<!--								</select>-->
							<!--							</label>-->
							<label><span>First name </span>
								<div
									v-if="form.errors.get('new_clients.' + newClientIndex + '.name_first')"
									class="error-block">
									<p v-html="form.errors.get('new_clients.' + newClientIndex + '.name_first')"></p>
								</div>
								<input v-model="form.data.new_clients[newClientIndex].name_first" type="text">
							</label>
							<label><span>Last name </span>
								<div
									v-if="form.errors.get('new_clients.' + newClientIndex + '.name_last')"
									class="error-block">
									<p v-html="form.errors.get('new_clients.' + newClientIndex + '.name_last')"></p>
								</div>
								<input v-model="form.data.new_clients[newClientIndex].name_last" type="text">
							</label>
							<label><span>Email </span>
								<div
									v-if="form.errors.get('new_clients.' + newClientIndex + '.email')"
									class="error-block">
									<p v-html="form.errors.get('new_clients.' + newClientIndex + '.email')"></p>
								</div>
								<input v-model="form.data.new_clients[newClientIndex].email" type="text">
							</label>
							<label><span>Phone </span>
								<div
									v-if="form.errors.get('new_clients.' + newClientIndex + '.phone')"
									class="error-block">
									<p v-html="form.errors.get('new_clients.' + newClientIndex + '.phone')"></p>
								</div>
								<input v-model="form.data.new_clients[newClientIndex].phone" type="text">
							</label>
						</div>
					</div>
				</fieldset>
			</section>
			<section class="section">
				<div class="actions-aligned">
					<ul class="actions">
						<li>
							<process-button
								:processing="form.processing" :text="$attrs.cta" class="button button--primary"/>
						</li>
					</ul>
				</div>
			</section>
		</div>
	</form>
</template>
<script>

export default {

	data() {
		return {
			form: this.newForm({
				client: {
					internal_reference: "",
					// title: "",
					name_first: "",
					name_last: "",
					email: "",
					dob: "",
					phone: "",
				},
				related_clients: [{
					// title: "",
					name_first: "",
					name_last: "",
					email: "",
					dob: "",
					phone: "",
				}],
				additional_id_checks: false,
				number_of_additional_id_checks: 1,
				new_clients: [{
					// title: "",
					name_first: "",
					name_last: "",
					email: "",
					dob: "",
					phone: "",
				}],
			}),
		};
	},

	props: {
		client: {
			required: true,
			type: Object,
		},
	},

	methods: {
		setNewClients() {
			console.log("setNewClients");
			this.form.setInstances("new_clients", this.form.data.number_of_additional_id_checks);
		},
		async submit() {
			this.form.post(this.route("clients/:client/id-checks", this.client)).then(response => {
				console.log(response);
				this.$router.push({
					name: "clients.show", params: {
						client: this.client.id,
						invoice: response.invoice,
					},
				});
				// _.each(response.data, function(model) {
				// 	this.addModel(model)
				// }.bind(this))
				// this.$store.dispatch('alerts/success', 'ID Checks Ordered')
			});
		},
	},

	created() {
		this.form.set("client", {
			internal_reference: this.client.internal_reference || "",
			title: this.client.title || "",
			name_first: this.client.name_first || "",
			name_last: this.client.name_last || "",
			email: this.client.email || "",
			dob: this.client.dob || "",
			phone: this.client.phone || "",
		});

		this.form.set("related_clients", _.map(this.client.relatedClients, (client) => {
			return {
				title: client.title || "",
				name_first: client.name_first || "",
				name_last: client.name_last || "",
				email: client.email || "",
				phone: client.phone || "",
			};
		}));

		this.setNewClients();

		// this.form.setInstances('new_clients', this.form.data.number_of_additional_id_checks)
	},
};
</script>
